import Api from '@/services/Index';

const getStudentOutOfRequests = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/esl/out-of-country-request/student/index', data);
}

const getStudentInformation = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/esl/out-of-country-request/student-form');
}
const saveRequest = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/esl/out-of-country-request/store',data);
}
const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/esl/out-of-country-request',config);
}
const show = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/esl/out-of-country-request/'+id);
}
const del = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/esl/out-of-country-request/'+id);
}

const confirmationUpdateStep = async (id,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put(`/esl/out-of-country-request/${id}/review`,data);
}
const uploadFile = async (id,formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post(`/esl/out-of-country-request/${id}/ticket-upload`,formData,{
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}
const dateFinalized = async (id,formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put(`/esl/out-of-country-request/${id}/mentora-admin/date-approve`,formData);
}
const i20Upload = async (id,formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post(`/esl/out-of-country-request/${id}/dso/fileupload`,formData,{
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}
export default {
    getStudentOutOfRequests,
    getStudentInformation,
    saveRequest,
    getAll,
    show,
    confirmationUpdateStep,
    uploadFile,
    dateFinalized,
    i20Upload,
    del
}
